import React from 'react';
import AudioPrompt from './AudioPrompt';

export default function ImageSelectQuestion({ question, value, onChange, disabled = false }) {
  const { config } = question;
  const audioPrompt = config?.audio_prompt;
  const images = config?.images || [];

  const handleSelect = (label) => {
    if (disabled) return;
    onChange(label);
  };

  return (
    <div className="space-y-4">
      {/* Audio prompt for young students */}
      {audioPrompt && <AudioPrompt text={audioPrompt} autoPlay />}

      {/* Image grid */}
      <div className={`grid gap-4 ${images.length <= 2 ? 'grid-cols-2' : 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4'}`}>
        {images.map((image, index) => {
          const isSelected = value === image.label;
          return (
            <button
              key={index}
              type="button"
              onClick={() => handleSelect(image.label)}
              disabled={disabled}
              className={`relative p-2 rounded-xl border-4 transition-all ${
                isSelected
                  ? 'border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200'
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              } ${disabled ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
            >
              <div className="aspect-square flex items-center justify-center p-2">
                {image.url ? (
                  <img
                    src={image.url}
                    alt={image.label}
                    className="max-w-full max-h-full object-contain"
                  />
                ) : (
                  // Fallback to label display if no image URL
                  <span className="text-4xl font-bold text-gray-700">{image.label}</span>
                )}
              </div>

              {/* Selection indicator */}
              {isSelected && (
                <div className="absolute top-2 right-2 w-6 h-6 bg-indigo-500 rounded-full flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}
            </button>
          );
        })}
      </div>

      {/* Accessibility: show text labels below for screen readers */}
      <div className="sr-only">
        {images.map((image, index) => (
          <span key={index}>Option {index + 1}: {image.label}. </span>
        ))}
      </div>
    </div>
  );
}
